(function() {
	'use strict';

	var DEFAULT_PRIMARY_FILE = {
		name: '(No file)'
	};

	angular
		.module('assetCommon')
		.factory('assetMapper', assetMapper);

	function assetMapper(_, assetUtility, uriUtility, formatMapper, userMapper, fileMapper, revisionMapper) {
		function getDownloadPathForFile(baseUrl, fileId, revId) {
			return uriUtility.fromPattern(baseUrl + '/files/{fileId}/content', { fileId: fileId, rev: revId });
		}

		function mapAsset(source, assetServiceBaseUri) {
			if (!source)
				return undefined;

			if (_.isArray(source))
				return source.map(mapAsset);

			if (!source.file)
				source.file = DEFAULT_PRIMARY_FILE;

			var metadata = source.metadata || {};
			var license = metadata.license || {};
			var creation = source.creation || {};
			var appMetadata = source.appData && source.appData.metadata || {};
			var userMetadata = source.userData && source.userData.metadata || {};

			var formats = source.formats && source.formats.map(function (format) {
				return formatMapper.map(format, source.id, source.revision.id);
			});

			var families = _.map(metadata.families || [], function (familyName) {
				return {
					name: familyName,
					data: _.cloneDeep(metadata[familyName] || {})
				};
			});

			return {
				id: source.id,
				bucket: source.bucket,
				kind: source.kind,
				title: metadata.title,
				description: metadata.description,
				date: metadata.date,
				language: metadata.language,
				authors: metadata.authors,
				headline: metadata.headline,
				note: metadata.note,
				status: metadata.status,
				tags: metadata.tags,
				categories: metadata.categories,
				copyright: metadata.copyright,
				publisher: metadata.publisher,
				familyMetadata: metadata.familyData,
				location: metadata.location,
				webStatement: license.webStatement,
				licenseTerms: license.usageTerms,
				rights: license.rights,
				favorite: userMetadata.favorite,
				dateCreated: creation.date,
				uploadId: metadata.uploadId,
				other: metadata.other,
				isDeleted: !!source.isDeleted,
				formats: formats,
				families: families,
				rating: userMetadata.rating,
				views: source.stats && source.stats.views.count,
				downloads: source.stats && source.stats.downloads && _.reduce(source.stats.downloads, function (sum, x) {
					return sum + x.counter.count;
				}, 0),

				get globalRating() { return appMetadata.ratingTotal && appMetadata.ratingCount && (appMetadata.ratingTotal / appMetadata.ratingCount); },

				globalRatingCount: appMetadata.ratingCount || 0,
				globalFavoriteCount: appMetadata.favoriteCount || 0,

				get baseUrl() { return uriUtility.fromPattern(assetServiceBaseUri + 'assets/{id}', { id: this.id }); },
				get fileUrl() { return this.file && getDownloadPathForFile(this.baseUrl, this.file.id, this.revision.id); },
				get sourceUrl() { return this.source && getDownloadPathForFile(this.baseUrl, this.source.id, this.revision.id); },

				getBestThumbnailForSize: function (size) {
					return assetUtility.getBestThumbnailForSize(this, size, assetServiceBaseUri);
				},
				getBestFormatForSize: function (size) {
					return assetUtility.getBestFormatForSize(this, size);
				},
				getVideoSourcesForSize: function (size) {
					return assetUtility.getVideoSourcesForSize(this, size, assetServiceBaseUri);
				},
				getAudioSources: function () {
					return assetUtility.getAudioSources(this, assetServiceBaseUri);
				},
				getDownloadPathForFile: function (file) {
					return getDownloadPathForFile(this.baseUrl, file.id, this.revision.id);
				},

				creator: userMapper.map(creation.agent && creation.agent.user),
				file: fileMapper.map(source.file, source.id, source.revision && source.revision.id),
				source: fileMapper.map(source.source, source.id, source.revision && source.revision.id),
				revision: revisionMapper.map(source.revision),
				boardIds: appMetadata.boardIds
			};
		}

		return {
			map: mapAsset
		};
	}
	assetMapper.$inject = ['_', 'assetUtility', 'uriUtility', 'formatMapper', 'userMapper', 'fileMapper', 'revisionMapper'];
})();